module.exports = __webpack_public_path__ + "static/media/resync_all.a1021c1f.svg";